import React, { Component } from 'react';
import config, { get } from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Select from 'react-select';

import { Link, Redirect } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import getLocale from '../../i18n/getLocale';


class FatigueReasonReportsAdd extends Component {
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      fatigue_reason_id: null,
      pontual_issue: this.locale.general.nao,
      observations: '',
      observations: '',
      date: '',
      fatigue_reasons: [],
      pontual_issue_list: [
        {value: 'Não', label: this.locale.general.nao},
        {value: 'Sim', label: this.locale.general.sim}
      ],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/fadigas/motivos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/parametros-de-fadiga');
        if (responseJson.status === 'success') {
          self.setState({
            fatigue_reasons: responseJson.data,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }


  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      fatigue_reason_id: this.state.fatigue_reason_id,
      date: this.state.date,
      observations: this.state.observations,
      pontual_issue: this.state.pontual_issue,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/reporte/voluntario/fadiga', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.titulo}</h3>
      <div className="clearfix"></div>
      <hr/>
      <div>
        <form onSubmit={this.add}>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.Motivo}:</label>
                <Select
                  className="form-field-name"
                  name="fatigue_reason_id"
                  value={this.state.fatigue_reason_id}
                  searchable={true}
                  placeholder={this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.placeholder.SelecionarMotivo}
                  onChange={this.handleSelectChange.bind(this, 'fatigue_reason_id')}
                  options={this.state.fatigue_reasons}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.Data}:</label>
                <InputMask value={this.state.date} required maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>{this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.OProblemaApresentadoPodeSerAlgoPontual}?</label>
                <Select
                  className="form-field-name"
                  name="pontual_issue"
                  value={this.state.pontual_issue}
                  searchable={true}
                  placeholder={this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.placeholder.SelecionarOpcao}
                  onChange={this.handleSelectChange.bind(this, 'pontual_issue')}
                  options={this.state.pontual_issue_list}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>{this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.Observacoes}:</label>
                <input type="text" name="observations" className="form-control" placeholder="" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.botaoEnviarReporte}</button>
            </div>
          </div>
        </form>
      </div>
      <hr/>
    </div>
  </div>
</div>
    );
  }
}

export default FatigueReasonReportsAdd;



// WEBPACK FOOTER //
// ./src/Components/FatigueReasons/FatigueReasonReportsAdd.js